export type ParagraphSectionMenuPosition = {
  top: number;
  left: number;
};

export const PARAGRAPH_SECTION_MENU_TRIGGER_OFFSET_PX = 28;
export const PARAGRAPH_SECTION_MENU_TRIGGER_TOP_OFFSET_PX = 2;
export const PARAGRAPH_SECTION_MENU_APPROACH_PADDING_PX = 10;

export function resolveParagraphSectionMenuAnchor(paragraphDom: HTMLElement): HTMLElement {
  const listItem = paragraphDom.closest('li');
  if (listItem instanceof HTMLElement) {
    return listItem;
  }
  return paragraphDom;
}

export function positionParagraphSectionMenu(
  paragraphDom: HTMLElement,
  options?: {
    offsetPx?: number;
    topOffsetPx?: number;
  },
): ParagraphSectionMenuPosition {
  const offsetPx = options?.offsetPx ?? PARAGRAPH_SECTION_MENU_TRIGGER_OFFSET_PX;
  const topOffsetPx = options?.topOffsetPx ?? PARAGRAPH_SECTION_MENU_TRIGGER_TOP_OFFSET_PX;
  const rect = resolveParagraphSectionMenuAnchor(paragraphDom).getBoundingClientRect();
  return {
    top: rect.top + topOffsetPx,
    left: rect.left - offsetPx,
  };
}

export function isPointerApproachingParagraphSectionMenu(
  paragraphDom: HTMLElement,
  clientX: number,
  clientY: number,
  options?: {
    offsetPx?: number;
    approachPaddingPx?: number;
  },
): boolean {
  const offsetPx = options?.offsetPx ?? PARAGRAPH_SECTION_MENU_TRIGGER_OFFSET_PX;
  const approachPaddingPx = options?.approachPaddingPx ?? PARAGRAPH_SECTION_MENU_APPROACH_PADDING_PX;
  const rect = resolveParagraphSectionMenuAnchor(paragraphDom).getBoundingClientRect();
  const left = rect.left - offsetPx - approachPaddingPx;
  const right = rect.left + approachPaddingPx;
  const top = rect.top - approachPaddingPx;
  const bottom = rect.top + 36 + approachPaddingPx;
  return clientX >= left && clientX <= right && clientY >= top && clientY <= bottom;
}
